var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.998 59.427h-.006c-1.407-.014-18.112-10.154-18.112-20.572 0-6.069 4.653-10.824 10.593-10.824 3.7 0 6.186 1.468 7.537 2.58 1.317-1.126 3.738-2.58 7.45-2.58 5.979 0 10.661 4.755 10.661 10.824 0 3.902-2.213 8.067-6.576 12.38-4.123 4.075-10.376 8.191-11.547 8.192Zm-7.525-28.396c-4.258 0-7.593 3.437-7.593 7.824 0 7.75 12.174 15.77 15.129 17.405 2.861-1.606 15.112-9.697 15.112-17.405 0-4.388-3.365-7.824-7.661-7.824-4.247 0-6.133 2.476-6.211 2.581-.281.38-.731.611-1.204.613h-.006c-.471 0-.919-.214-1.203-.591-.075-.096-2.085-2.604-6.363-2.604Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.817 91.214a1.5 1.5 0 0 1-1.5-1.5v-66.61c0-4.993 4.062-9.056 9.056-9.056h59.254c4.993 0 9.056 4.062 9.056 9.056v38.491c0 4.993-4.062 9.056-9.056 9.056H31.3L13.951 90.696c-.29.336-.707.519-1.134.519Zm7.556-74.165a6.063 6.063 0 0 0-6.056 6.056v62.584l15.163-17.52a1.498 1.498 0 0 1 1.134-.519h49.013a6.063 6.063 0 0 0 6.056-6.056v-38.49a6.063 6.063 0 0 0-6.056-6.056H20.373Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLove);
export default __webpack_public_path__ + "static/media/chat-love.f633af29e6a5e1dd2d67c358c4632715.svg";
export { ForwardRef as ReactComponent };